// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMEvaluationModule-module__font-s-10____3oCi {
  font-size: 10px !important;
}

.CGMEvaluationModule-module__font-s-12___sYIGD {
  font-size: 12px !important;
}

.CGMEvaluationModule-module__font-s-13___nNa1O {
  font-size: 13px !important;
}

.CGMEvaluationModule-module__font-s-14___aPCn1 {
  font-size: 14px !important;
}

.CGMEvaluationModule-module__font-s-15___RLqud {
  font-size: 15px !important;
}

.CGMEvaluationModule-module__font-s-16___ytElj {
  font-size: 16px !important;
}

.CGMEvaluationModule-module__font-s-18___c4lyn {
  font-size: 18px !important;
}

.CGMEvaluationModule-module__font-s-20___GGEEU {
  font-size: 20px !important;
}

.CGMEvaluationModule-module__font-s-22___eClRM {
  font-size: 22px !important;
}

.CGMEvaluationModule-module__font-s-28___iwijk {
  font-size: 28px !important;
}

.CGMEvaluationModule-module__font-w-400___UPwud {
  font-weight: 400 !important;
}

.CGMEvaluationModule-module__font-w-500___mq1OV {
  font-weight: 500 !important;
}

.CGMEvaluationModule-module__font-w-600___Ajosg {
  font-weight: 600 !important;
}

.CGMEvaluationModule-module__font-w-700___vJE9V {
  font-weight: 700 !important;
}

.CGMEvaluationModule-module__p-5___XteCA {
  padding: 5px !important;
}

.CGMEvaluationModule-module__p-12___owzKW {
  padding: 12px !important;
}

.CGMEvaluationModule-module__p-16___pJR9s {
  padding: 16px !important;
}

.CGMEvaluationModule-module__p-30___At2fC {
  padding: 30px !important;
}

.CGMEvaluationModule-module__p-b-0___E0lj7 {
  padding-bottom: 0 !important;
}

.CGMEvaluationModule-module__p-b-5___yB3xV {
  padding-bottom: 5px !important;
}

.CGMEvaluationModule-module__p-b-10___YVpRD {
  padding-bottom: 10px !important;
}

.CGMEvaluationModule-module__p-b-12___dSZ10 {
  padding-bottom: 12px !important;
}

.CGMEvaluationModule-module__p-b-16___h6ook {
  padding-bottom: 16px !important;
}

.CGMEvaluationModule-module__p-b-18___tVXtc {
  padding-bottom: 18px !important;
}

.CGMEvaluationModule-module__p-b-20___Xcnfq {
  padding-bottom: 20px !important;
}

.CGMEvaluationModule-module__p-b-25___APfGq {
  padding-bottom: 25px !important;
}

.CGMEvaluationModule-module__p-b-30___GDFBf {
  padding-bottom: 30px !important;
}

.CGMEvaluationModule-module__p-b-50___bc69Y {
  padding-bottom: 50px !important;
}

.CGMEvaluationModule-module__p-t-0___qhjzN {
  padding-top: 0 !important;
}

.CGMEvaluationModule-module__p-t-12___SX3WH {
  padding-top: 12px !important;
}

.CGMEvaluationModule-module__p-t-16___F1ghf {
  padding-top: 16px !important;
}

.CGMEvaluationModule-module__p-t-18___njGu2 {
  padding-top: 18px !important;
}

.CGMEvaluationModule-module__p-t-20___gNfML {
  padding-top: 20px !important;
}

.CGMEvaluationModule-module__p-t-30___h3BbT {
  padding-top: 30px !important;
}

.CGMEvaluationModule-module__p-t-40___M8N3N {
  padding-top: 40px !important;
}

.CGMEvaluationModule-module__p-t-50___c4tEp {
  padding-top: 50px !important;
}

.CGMEvaluationModule-module__p-l-20___NIjrz {
  padding-left: 20px !important;
}

.CGMEvaluationModule-module__p-l-30___u_efI {
  padding-left: 30px !important;
}

.CGMEvaluationModule-module__p-l-40___lFrEk {
  padding-left: 40px !important;
}

.CGMEvaluationModule-module__p-r-16___xP1QT {
  padding-right: 16px !important;
}

.CGMEvaluationModule-module__p-r-20___hPcB_ {
  padding-right: 20px !important;
}

.CGMEvaluationModule-module__p-r-30___BM68p {
  padding-right: 30px !important;
}

.CGMEvaluationModule-module__p-r-50___dvaf2 {
  padding-right: 50px !important;
}

.CGMEvaluationModule-module__p-r-60___t3JpT {
  padding-right: 60px !important;
}

.CGMEvaluationModule-module__m-b-1___RT11F {
  margin-bottom: 1px !important;
}

.CGMEvaluationModule-module__m-b-2___welIA {
  margin-bottom: 2px !important;
}

.CGMEvaluationModule-module__m-b-6___lHUf3 {
  margin-bottom: 6px !important;
}

.CGMEvaluationModule-module__m-b-8___mMXg6 {
  margin-bottom: 8px !important;
}

.CGMEvaluationModule-module__m-b-10___Ve_sI {
  margin-bottom: 10px !important;
}

.CGMEvaluationModule-module__m-b-14___U8avd {
  margin-bottom: 14px !important;
}

.CGMEvaluationModule-module__m-b-16___oyLd4 {
  margin-bottom: 16px !important;
}

.CGMEvaluationModule-module__m-b-20___NZGLr {
  margin-bottom: 20px !important;
}

.CGMEvaluationModule-module__m-b-22___njhK5 {
  margin-bottom: 22px !important;
}

.CGMEvaluationModule-module__m-b-24___ljG9D {
  margin-bottom: 24px !important;
}

.CGMEvaluationModule-module__m-b-30___Dm_Vp {
  margin-bottom: 30px !important;
}

.CGMEvaluationModule-module__m-b-32___buKOh {
  margin-bottom: 32px !important;
}

.CGMEvaluationModule-module__m-b-40___QZXcJ {
  margin-bottom: 40px !important;
}

.CGMEvaluationModule-module__m-t-2___RmsGm {
  margin-top: 2px !important;
}

.CGMEvaluationModule-module__m-t-3____j2lp {
  margin-top: 3px !important;
}

.CGMEvaluationModule-module__m-t-4___qDflm {
  margin-top: 4px !important;
}

.CGMEvaluationModule-module__m-t-5___OXpoR {
  margin-top: 5px !important;
}

.CGMEvaluationModule-module__m-t-8___T8XN6 {
  margin-top: 8px !important;
}

.CGMEvaluationModule-module__m-t-10___dzKPQ {
  margin-top: 10px !important;
}

.CGMEvaluationModule-module__m-t-15___LyqF9 {
  margin-top: 15px !important;
}

.CGMEvaluationModule-module__m-t-16___x56fT {
  margin-top: 16px !important;
}

.CGMEvaluationModule-module__m-t-20___QD6FQ {
  margin-top: 20px !important;
}

.CGMEvaluationModule-module__m-t-22___JannM {
  margin-top: 22px !important;
}

.CGMEvaluationModule-module__m-t-30___E1lM_ {
  margin-top: 30px !important;
}

.CGMEvaluationModule-module__m-t-32___NxnkA {
  margin-top: 32px !important;
}

.CGMEvaluationModule-module__m-l-auto___V7r65 {
  margin-left: auto !important;
}

.CGMEvaluationModule-module__m-l-4___TTyz4 {
  margin-left: 4px !important;
}

.CGMEvaluationModule-module__m-l-5___BS9VS {
  margin-left: 5px !important;
}

.CGMEvaluationModule-module__m-l-6___Rqc0D {
  margin-left: 6px !important;
}

.CGMEvaluationModule-module__m-l-8___ShOWH {
  margin-left: 8px !important;
}

.CGMEvaluationModule-module__m-l-10___ZXs6r {
  margin-left: 10px !important;
}

.CGMEvaluationModule-module__m-l-16___mjUhT {
  margin-left: 16px !important;
}

.CGMEvaluationModule-module__m-l-20___p2M32 {
  margin-left: 20px !important;
}

.CGMEvaluationModule-module__m-l-24___dXMOd {
  margin-left: 24px !important;
}

.CGMEvaluationModule-module__m-l-30___shpEJ {
  margin-left: 30px !important;
}

.CGMEvaluationModule-module__m-l-35___cRlhC {
  margin-left: 35px !important;
}

.CGMEvaluationModule-module__m-l-40___Qcr0f {
  margin-left: 40px !important;
}

.CGMEvaluationModule-module__m-r-8___bb1cJ {
  margin-right: 8px !important;
}

.CGMEvaluationModule-module__m-r-10___VFGRv {
  margin-right: 10px !important;
}

.CGMEvaluationModule-module__m-r-16___RT9GA {
  margin-right: 16px !important;
}

.CGMEvaluationModule-module__m-r-20___oUaTz {
  margin-right: 20px !important;
}

.CGMEvaluationModule-module__m-r-24___KgqSw {
  margin-right: 24px !important;
}

.CGMEvaluationModule-module__m-r-30___OuZ7q {
  margin-right: 30px !important;
}

.CGMEvaluationModule-module__m-r-40___YTP5b {
  margin-right: 40px !important;
}

.CGMEvaluationModule-module__border-r-3___fVPTq {
  border-radius: 3px !important;
}

.CGMEvaluationModule-module__border-r-4___kDOCU {
  border-radius: 4px !important;
}

.CGMEvaluationModule-module__border-r-6___ai5V5 {
  border-radius: 6px !important;
}

.CGMEvaluationModule-module__border-r-10___Qcziq {
  border-radius: 10px !important;
}

.CGMEvaluationModule-module__border-r-12___RYVmd {
  border-radius: 12px !important;
}

.CGMEvaluationModule-module__border-r-16___gyLpH {
  border-radius: 16px !important;
}

.CGMEvaluationModule-module__border-r-50___d2GXb {
  border-radius: 50% !important;
}

.CGMEvaluationModule-module__primary-border___TLFvq {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMEvaluationModule-module__primary-border-b___D7XcZ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMEvaluationModule-module__primary-border-t___EUP2f {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMEvaluationModule-module__primary-border-l___OeGCO {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMEvaluationModule-module__primary-border-r____xuJz {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMEvaluationModule-module__secondary-border___rbNP7 {
  border: 1px solid #637768;
}

.CGMEvaluationModule-module__secondary-border-b___lfvJl {
  border-bottom: 1px solid #637768;
}

.CGMEvaluationModule-module__secondary-border-t___d5OO_ {
  border-top: 1px solid #637768;
}

.CGMEvaluationModule-module__secondary-border-l___ZMpiQ {
  border-left: 1px solid #637768;
}

.CGMEvaluationModule-module__secondary-border-r___tJScN {
  border-right: 1px solid #637768;
}

.CGMEvaluationModule-module__gap-0___ynH3C {
  gap: 0 !important;
}

.CGMEvaluationModule-module__gap-2___WtSz7 {
  gap: 2px !important;
}

.CGMEvaluationModule-module__gap-4___nyjDY {
  gap: 4px !important;
}

.CGMEvaluationModule-module__gap-5___MML_N {
  gap: 5px !important;
}

.CGMEvaluationModule-module__gap-6___YxzOP {
  gap: 6px !important;
}

.CGMEvaluationModule-module__gap-8___XtBZY {
  gap: 8px !important;
}

.CGMEvaluationModule-module__gap-10___suhp8 {
  gap: 10px !important;
}

.CGMEvaluationModule-module__gap-12___HH5LU {
  gap: 12px !important;
}

.CGMEvaluationModule-module__gap-14___Jvhy0 {
  gap: 14px !important;
}

.CGMEvaluationModule-module__gap-16___DYQ02 {
  gap: 16px !important;
}

.CGMEvaluationModule-module__gap-18___aP0ja {
  gap: 18px !important;
}

.CGMEvaluationModule-module__gap-20___o6bRL {
  gap: 20px !important;
}

.CGMEvaluationModule-module__gap-24___k2Uqg {
  gap: 24px !important;
}

.CGMEvaluationModule-module__gap-26___xCJoI {
  gap: 26px !important;
}

.CGMEvaluationModule-module__gap-30___zwoJN {
  gap: 30px !important;
}

.CGMEvaluationModule-module__gap-32___XF9gY {
  gap: 32px !important;
}

.CGMEvaluationModule-module__gap-40___HGQxo {
  gap: 40px !important;
}

.CGMEvaluationModule-module__gap-50___GFyLf {
  gap: 50px !important;
}

.CGMEvaluationModule-module__flex-1___bwLHM {
  flex: 1;
}

.CGMEvaluationModule-module__flex-none___ZqPX0 {
  flex: none !important;
}

.CGMEvaluationModule-module__flex-column___PQk92 {
  display: flex;
  flex-direction: column !important;
}

.CGMEvaluationModule-module__flex-row___Wgjpj {
  display: flex;
  flex-direction: row !important;
}

.CGMEvaluationModule-module__vertically-centered___n39uC {
  display: flex;
  align-items: center !important;
}

.CGMEvaluationModule-module__horizontally-centered___OzaOE {
  display: flex;
  justify-content: center !important;
}

.CGMEvaluationModule-module__horizontally-end___nAUfp {
  display: flex;
  justify-content: end !important;
}

.CGMEvaluationModule-module__vertically-start___ZtYr9 {
  display: flex;
  align-items: start !important;
}

.CGMEvaluationModule-module__space-between___x8IXh {
  display: flex;
  justify-content: space-between !important;
}

.CGMEvaluationModule-module__flex-wrap___UaTCF {
  flex-wrap: wrap !important;
}

.CGMEvaluationModule-module__height-100___q0JwI {
  height: 100%;
}

.CGMEvaluationModule-module__width-50___w8Ivx {
  width: 50% !important;
}

.CGMEvaluationModule-module__width-100___eFXah {
  width: 100%;
}

.CGMEvaluationModule-module__cursor-pointer___V5Zti {
  cursor: pointer;
}

.CGMEvaluationModule-module__cursor-not-allowed___rg8ok {
  cursor: not-allowed !important;
}

.CGMEvaluationModule-module__absolute-centered___W94l0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMEvaluationModule-module__absolute___inLZA {
  position: absolute;
}

.CGMEvaluationModule-module__relative___i2asN {
  position: relative;
}

.CGMEvaluationModule-module__fixed____d6d9 {
  position: fixed;
}

.CGMEvaluationModule-module__visible___gC97b {
  opacity: 1;
}

.CGMEvaluationModule-module__invisible___CEmJc {
  opacity: 0;
}

.CGMEvaluationModule-module__col-90___DeBd1 {
  width: 90% !important;
}

.CGMEvaluationModule-module__col-auto___V7JtI {
  width: auto !important;
}

.CGMEvaluationModule-module__medical-tabs___ekdJF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMEvaluationModule-module__medical-table-new___UT7Kr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr::-webkit-scrollbar-track {
  display: none;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr.CGMEvaluationModule-module__no-pagination___vzxx9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr.CGMEvaluationModule-module__no-pagination___vzxx9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr.CGMEvaluationModule-module__no-pagination___vzxx9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMEvaluationModule-module__medical-table-new___UT7Kr.CGMEvaluationModule-module__no-pagination___vzxx9::-webkit-scrollbar-track {
  display: none;
}

.CGMEvaluationModule-module__medical-table-empty___cq4Qk {
  padding: 14px 40px !important;
}

.CGMEvaluationModule-module__icon-btn___QCcce {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMEvaluationModule-module__search-icon___NOovf {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMEvaluationModule-module__disable-select___ZReyY {
  user-select: none;
}

.CGMEvaluationModule-module__break-word___rpN7r {
  word-break: break-word;
}

.CGMEvaluationModule-module__popup-clear-btn___nO1sC {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMEvaluationModule-module__scroll-m-b-20___Vj34S {
  scroll-margin-bottom: 20px;
}

.CGMEvaluationModule-module__container___oT_JV {
  max-width: 40vw;
  color: #375844;
  padding-right: 30px;
}

.CGMEvaluationModule-module__width50___sD6Q1 {
  width: 50% !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/CGMEvaluationModule/CGMEvaluationModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  max-width: 40vw;\n  color: get-color(greenNew, dark);\n  padding-right: 30px;\n}\n\n.width50 {\n  width: 50% !important;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMEvaluationModule-module__font-s-10____3oCi`,
	"fontS12": `CGMEvaluationModule-module__font-s-12___sYIGD`,
	"fontS13": `CGMEvaluationModule-module__font-s-13___nNa1O`,
	"fontS14": `CGMEvaluationModule-module__font-s-14___aPCn1`,
	"fontS15": `CGMEvaluationModule-module__font-s-15___RLqud`,
	"fontS16": `CGMEvaluationModule-module__font-s-16___ytElj`,
	"fontS18": `CGMEvaluationModule-module__font-s-18___c4lyn`,
	"fontS20": `CGMEvaluationModule-module__font-s-20___GGEEU`,
	"fontS22": `CGMEvaluationModule-module__font-s-22___eClRM`,
	"fontS28": `CGMEvaluationModule-module__font-s-28___iwijk`,
	"fontW400": `CGMEvaluationModule-module__font-w-400___UPwud`,
	"fontW500": `CGMEvaluationModule-module__font-w-500___mq1OV`,
	"fontW600": `CGMEvaluationModule-module__font-w-600___Ajosg`,
	"fontW700": `CGMEvaluationModule-module__font-w-700___vJE9V`,
	"p5": `CGMEvaluationModule-module__p-5___XteCA`,
	"p12": `CGMEvaluationModule-module__p-12___owzKW`,
	"p16": `CGMEvaluationModule-module__p-16___pJR9s`,
	"p30": `CGMEvaluationModule-module__p-30___At2fC`,
	"pB0": `CGMEvaluationModule-module__p-b-0___E0lj7`,
	"pB5": `CGMEvaluationModule-module__p-b-5___yB3xV`,
	"pB10": `CGMEvaluationModule-module__p-b-10___YVpRD`,
	"pB12": `CGMEvaluationModule-module__p-b-12___dSZ10`,
	"pB16": `CGMEvaluationModule-module__p-b-16___h6ook`,
	"pB18": `CGMEvaluationModule-module__p-b-18___tVXtc`,
	"pB20": `CGMEvaluationModule-module__p-b-20___Xcnfq`,
	"pB25": `CGMEvaluationModule-module__p-b-25___APfGq`,
	"pB30": `CGMEvaluationModule-module__p-b-30___GDFBf`,
	"pB50": `CGMEvaluationModule-module__p-b-50___bc69Y`,
	"pT0": `CGMEvaluationModule-module__p-t-0___qhjzN`,
	"pT12": `CGMEvaluationModule-module__p-t-12___SX3WH`,
	"pT16": `CGMEvaluationModule-module__p-t-16___F1ghf`,
	"pT18": `CGMEvaluationModule-module__p-t-18___njGu2`,
	"pT20": `CGMEvaluationModule-module__p-t-20___gNfML`,
	"pT30": `CGMEvaluationModule-module__p-t-30___h3BbT`,
	"pT40": `CGMEvaluationModule-module__p-t-40___M8N3N`,
	"pT50": `CGMEvaluationModule-module__p-t-50___c4tEp`,
	"pL20": `CGMEvaluationModule-module__p-l-20___NIjrz`,
	"pL30": `CGMEvaluationModule-module__p-l-30___u_efI`,
	"pL40": `CGMEvaluationModule-module__p-l-40___lFrEk`,
	"pR16": `CGMEvaluationModule-module__p-r-16___xP1QT`,
	"pR20": `CGMEvaluationModule-module__p-r-20___hPcB_`,
	"pR30": `CGMEvaluationModule-module__p-r-30___BM68p`,
	"pR50": `CGMEvaluationModule-module__p-r-50___dvaf2`,
	"pR60": `CGMEvaluationModule-module__p-r-60___t3JpT`,
	"mB1": `CGMEvaluationModule-module__m-b-1___RT11F`,
	"mB2": `CGMEvaluationModule-module__m-b-2___welIA`,
	"mB6": `CGMEvaluationModule-module__m-b-6___lHUf3`,
	"mB8": `CGMEvaluationModule-module__m-b-8___mMXg6`,
	"mB10": `CGMEvaluationModule-module__m-b-10___Ve_sI`,
	"mB14": `CGMEvaluationModule-module__m-b-14___U8avd`,
	"mB16": `CGMEvaluationModule-module__m-b-16___oyLd4`,
	"mB20": `CGMEvaluationModule-module__m-b-20___NZGLr`,
	"mB22": `CGMEvaluationModule-module__m-b-22___njhK5`,
	"mB24": `CGMEvaluationModule-module__m-b-24___ljG9D`,
	"mB30": `CGMEvaluationModule-module__m-b-30___Dm_Vp`,
	"mB32": `CGMEvaluationModule-module__m-b-32___buKOh`,
	"mB40": `CGMEvaluationModule-module__m-b-40___QZXcJ`,
	"mT2": `CGMEvaluationModule-module__m-t-2___RmsGm`,
	"mT3": `CGMEvaluationModule-module__m-t-3____j2lp`,
	"mT4": `CGMEvaluationModule-module__m-t-4___qDflm`,
	"mT5": `CGMEvaluationModule-module__m-t-5___OXpoR`,
	"mT8": `CGMEvaluationModule-module__m-t-8___T8XN6`,
	"mT10": `CGMEvaluationModule-module__m-t-10___dzKPQ`,
	"mT15": `CGMEvaluationModule-module__m-t-15___LyqF9`,
	"mT16": `CGMEvaluationModule-module__m-t-16___x56fT`,
	"mT20": `CGMEvaluationModule-module__m-t-20___QD6FQ`,
	"mT22": `CGMEvaluationModule-module__m-t-22___JannM`,
	"mT30": `CGMEvaluationModule-module__m-t-30___E1lM_`,
	"mT32": `CGMEvaluationModule-module__m-t-32___NxnkA`,
	"mLAuto": `CGMEvaluationModule-module__m-l-auto___V7r65`,
	"mL4": `CGMEvaluationModule-module__m-l-4___TTyz4`,
	"mL5": `CGMEvaluationModule-module__m-l-5___BS9VS`,
	"mL6": `CGMEvaluationModule-module__m-l-6___Rqc0D`,
	"mL8": `CGMEvaluationModule-module__m-l-8___ShOWH`,
	"mL10": `CGMEvaluationModule-module__m-l-10___ZXs6r`,
	"mL16": `CGMEvaluationModule-module__m-l-16___mjUhT`,
	"mL20": `CGMEvaluationModule-module__m-l-20___p2M32`,
	"mL24": `CGMEvaluationModule-module__m-l-24___dXMOd`,
	"mL30": `CGMEvaluationModule-module__m-l-30___shpEJ`,
	"mL35": `CGMEvaluationModule-module__m-l-35___cRlhC`,
	"mL40": `CGMEvaluationModule-module__m-l-40___Qcr0f`,
	"mR8": `CGMEvaluationModule-module__m-r-8___bb1cJ`,
	"mR10": `CGMEvaluationModule-module__m-r-10___VFGRv`,
	"mR16": `CGMEvaluationModule-module__m-r-16___RT9GA`,
	"mR20": `CGMEvaluationModule-module__m-r-20___oUaTz`,
	"mR24": `CGMEvaluationModule-module__m-r-24___KgqSw`,
	"mR30": `CGMEvaluationModule-module__m-r-30___OuZ7q`,
	"mR40": `CGMEvaluationModule-module__m-r-40___YTP5b`,
	"borderR3": `CGMEvaluationModule-module__border-r-3___fVPTq`,
	"borderR4": `CGMEvaluationModule-module__border-r-4___kDOCU`,
	"borderR6": `CGMEvaluationModule-module__border-r-6___ai5V5`,
	"borderR10": `CGMEvaluationModule-module__border-r-10___Qcziq`,
	"borderR12": `CGMEvaluationModule-module__border-r-12___RYVmd`,
	"borderR16": `CGMEvaluationModule-module__border-r-16___gyLpH`,
	"borderR50": `CGMEvaluationModule-module__border-r-50___d2GXb`,
	"primaryBorder": `CGMEvaluationModule-module__primary-border___TLFvq`,
	"primaryBorderB": `CGMEvaluationModule-module__primary-border-b___D7XcZ`,
	"primaryBorderT": `CGMEvaluationModule-module__primary-border-t___EUP2f`,
	"primaryBorderL": `CGMEvaluationModule-module__primary-border-l___OeGCO`,
	"primaryBorderR": `CGMEvaluationModule-module__primary-border-r____xuJz`,
	"secondaryBorder": `CGMEvaluationModule-module__secondary-border___rbNP7`,
	"secondaryBorderB": `CGMEvaluationModule-module__secondary-border-b___lfvJl`,
	"secondaryBorderT": `CGMEvaluationModule-module__secondary-border-t___d5OO_`,
	"secondaryBorderL": `CGMEvaluationModule-module__secondary-border-l___ZMpiQ`,
	"secondaryBorderR": `CGMEvaluationModule-module__secondary-border-r___tJScN`,
	"gap0": `CGMEvaluationModule-module__gap-0___ynH3C`,
	"gap2": `CGMEvaluationModule-module__gap-2___WtSz7`,
	"gap4": `CGMEvaluationModule-module__gap-4___nyjDY`,
	"gap5": `CGMEvaluationModule-module__gap-5___MML_N`,
	"gap6": `CGMEvaluationModule-module__gap-6___YxzOP`,
	"gap8": `CGMEvaluationModule-module__gap-8___XtBZY`,
	"gap10": `CGMEvaluationModule-module__gap-10___suhp8`,
	"gap12": `CGMEvaluationModule-module__gap-12___HH5LU`,
	"gap14": `CGMEvaluationModule-module__gap-14___Jvhy0`,
	"gap16": `CGMEvaluationModule-module__gap-16___DYQ02`,
	"gap18": `CGMEvaluationModule-module__gap-18___aP0ja`,
	"gap20": `CGMEvaluationModule-module__gap-20___o6bRL`,
	"gap24": `CGMEvaluationModule-module__gap-24___k2Uqg`,
	"gap26": `CGMEvaluationModule-module__gap-26___xCJoI`,
	"gap30": `CGMEvaluationModule-module__gap-30___zwoJN`,
	"gap32": `CGMEvaluationModule-module__gap-32___XF9gY`,
	"gap40": `CGMEvaluationModule-module__gap-40___HGQxo`,
	"gap50": `CGMEvaluationModule-module__gap-50___GFyLf`,
	"flex1": `CGMEvaluationModule-module__flex-1___bwLHM`,
	"flexNone": `CGMEvaluationModule-module__flex-none___ZqPX0`,
	"flexColumn": `CGMEvaluationModule-module__flex-column___PQk92`,
	"flexRow": `CGMEvaluationModule-module__flex-row___Wgjpj`,
	"verticallyCentered": `CGMEvaluationModule-module__vertically-centered___n39uC`,
	"horizontallyCentered": `CGMEvaluationModule-module__horizontally-centered___OzaOE`,
	"horizontallyEnd": `CGMEvaluationModule-module__horizontally-end___nAUfp`,
	"verticallyStart": `CGMEvaluationModule-module__vertically-start___ZtYr9`,
	"spaceBetween": `CGMEvaluationModule-module__space-between___x8IXh`,
	"flexWrap": `CGMEvaluationModule-module__flex-wrap___UaTCF`,
	"height100": `CGMEvaluationModule-module__height-100___q0JwI`,
	"width50": `CGMEvaluationModule-module__width-50___w8Ivx`,
	"width100": `CGMEvaluationModule-module__width-100___eFXah`,
	"cursorPointer": `CGMEvaluationModule-module__cursor-pointer___V5Zti`,
	"cursorNotAllowed": `CGMEvaluationModule-module__cursor-not-allowed___rg8ok`,
	"absoluteCentered": `CGMEvaluationModule-module__absolute-centered___W94l0`,
	"absolute": `CGMEvaluationModule-module__absolute___inLZA`,
	"relative": `CGMEvaluationModule-module__relative___i2asN`,
	"fixed": `CGMEvaluationModule-module__fixed____d6d9`,
	"visible": `CGMEvaluationModule-module__visible___gC97b`,
	"invisible": `CGMEvaluationModule-module__invisible___CEmJc`,
	"col90": `CGMEvaluationModule-module__col-90___DeBd1`,
	"colAuto": `CGMEvaluationModule-module__col-auto___V7JtI`,
	"medicalTabs": `CGMEvaluationModule-module__medical-tabs___ekdJF`,
	"medicalTableNew": `CGMEvaluationModule-module__medical-table-new___UT7Kr`,
	"noPagination": `CGMEvaluationModule-module__no-pagination___vzxx9`,
	"medicalTableEmpty": `CGMEvaluationModule-module__medical-table-empty___cq4Qk`,
	"iconBtn": `CGMEvaluationModule-module__icon-btn___QCcce`,
	"searchIcon": `CGMEvaluationModule-module__search-icon___NOovf`,
	"disableSelect": `CGMEvaluationModule-module__disable-select___ZReyY`,
	"breakWord": `CGMEvaluationModule-module__break-word___rpN7r`,
	"popupClearBtn": `CGMEvaluationModule-module__popup-clear-btn___nO1sC`,
	"scrollMB20": `CGMEvaluationModule-module__scroll-m-b-20___Vj34S`,
	"container": `CGMEvaluationModule-module__container___oT_JV`,
	"width50": `CGMEvaluationModule-module__width50___sD6Q1`
};
module.exports = ___CSS_LOADER_EXPORT___;
